import MusicIcon from "../../assets/images/admin/music.svg";
import ChartIcon from "../../assets/images/admin/chart.svg";
import ClothsIcon from "../../assets/images/admin/clothes.svg";
import BioLinkIcon from "../../assets/images/admin/bio-link.png";

const initialState = {
    loading: null,
    currentStep: 0,
    goalOptions: [
        { id: 1, value: "More Streams", icon: MusicIcon, desc: "Directly drive fans to stream your music", ctaOptions: ["Listen Now", "Play Now", "Play Music"] },
        { id: 2, value: "Spotify Growth", icon: "bi bi-spotify", desc: "Increase your Spotify followers", ctaOptions: ["Listen Now", "Learn More", "Listen Music", "See More", "Open Link", "Visit Profile", "Explore More"] },
        { id: 3, value: "Instagram Growth", icon: "bi bi-instagram", desc: "Increase your Instagram followers", ctaOptions: ["Learn More", "View Instagram Profile", "Visit Profile", "Interested", "Like Page", "Message Page", "Instagram Message", "See More", "Get In Touch", "Watch More", "Open Link", "Explore More", "Chat With Us", "View Channel"] },
        { id: 4, value: "Playlist Growth", icon: "bi bi-spotify", desc: "Grow your Spotify playlists", ctaOptions: ["Listen Now", "Learn More"] },
        { id: 5, value: "YouTube Growth", icon: "bi bi-youtube", desc: "Drive YouTube views for your videos via Meta", ctaOptions: ["Watch More", "Play Now", "Listen Now", "Follow Page", "Play Music", "Learn More"] },
        { id: 6, value: "Promote Custom Link", icon: ChartIcon, desc: "Promote your custom link, song, video or website", ctaOptions: ["Learn More", "Book Now", "Contact Us", "Message", "Open App", "Play Now", "Shop Now", "Sign Up", "Learn More", "Watch Now", "Listen Now", "Get Offer", "Email", "Buy Tickets", "Play Music", "Interested", "View Shop", "Follow Page", "View Inventory", "View Menu", "Creator Storefront"] },
        // { id: 6, value: "Pre-Save Link", icon: ChartIcon, desc: "Promote your smartlink, song, video or website", ctaOptions: ["Book Now", "Contact Us", "Message", "Open App", "Play Now", "Shop Now", "Sign Up", "Learn More", "Watch Now", "Listen Now", "Get Offer", "Email", "Buy Tickets", "Play Music", "Interested", "View Shop", "Follow Page", "View Inventory", "View Menu", "Creator Storefront"] },
        { id: 7, value: "Promote an Event", icon: "event-icon", desc: "Sell tickets to your upcoming shows", ctaOptions: ["Book Now", "Contact Us", "Message", "Shop Now", "Sign Up", "Buy Tickets", "Learn More", "Get Offer", "Interested"] },
        { id: 8, value: "Sell Your Merch", icon: ClothsIcon, desc: "Increase sales of your merch", ctaOptions: ["Shop Now", "Buy Now", "Listen Now", "Get Offer", "Learn More", "Interested", "View Shop", "View Inventory", "View Menu", "Creator Storefront"] },
        { id: 9, value: "Promote Bio Link", icon: BioLinkIcon, desc: "Turn visibility into real fans", ctaOptions: ["Shop Now", "Buy Now", "Listen Now", "Get Offer", "Learn More", "Interested", "View Shop", "View Inventory", "View Menu", "Creator Storefront"] }
    ],

    artistTrackList: [],
    artistTrackType: 'track', //['track', 'album', 'playlist','artist']
    artistSpotifyProfileUrl: '',
    selectedRelease: {},
    albumPlaylistTracks: {},
    selectedAlbumPlaylistTrack: {},
    formData: {
        adAccountList: [],
        pageList: [],
        objective: '',   // use for all type of camapign
        platformType: '', // use for all camapign
        metaLoggedIn: false,
        metaAuthPending: false, // true while exchanging Meta OAuth code after redirect
        youtubeLoggedIn: false,
        metaAccessToken: '',
        adAccountId: '',
        facebookUserId: '',
        pageId: '',
        pageAccessToken: '',
        shouldShowFeatureFM: false,
        instagramId: '',
        budget: 100,      // common meta & youtube
        budgetType: 'lifetime',
        currency: '',           // Meta ad account currency (e.g. USD, INR)
        minDailyBudget: null,   // Meta min daily (high freq) in account currency
        timezone: '',           // Meta ad account timezone (e.g. Asia/Kolkata)
        startDate: new Date(),     // common meta & youtube
        endDate: null,              // common meta & youtube
        startTime: "14:45",         // common meta & youtube
        endTime: "23:45",           // common meta & youtube
        code: '',
        campaignId: null,
        targeting: {
            ageRange: {
                min: 18, // Default min age (Adjustable)
                max: 65 // Default max age (Adjustable)
            },
            location: {
                countries: [], // List of country codes (ISO-3166)
                regions: [], // Optional: Specific regions
                cities: [], // Optional: Specific cities
                locationEnum: "global"
            },
            gender: 'All', // Default to 'All' (Can be 'Male', 'Female', or 'All')
            interests: [], // List of selected interest categories
            behaviors: [], // List of selected behavior categories
            languages: [], // Selected languages
            deviceTypes: [] // Targeted device types (e.g., mobile, desktop)
        },
        selectedLocationOption: "global",
        locationOption: [],
        suggestedIntrests: [],
        potentialReach: {
            min: 0,
            max: 0
        },

        // ad creativess data for meta
        mediaView: 'metaListing',   //  ['metaListing' ,'uploadSection']
        selectMediaBy: '',   // ['meta','upload']
        facebookMediaData: { photos: [], videos: [] },
        instagramMediaData: [], // data getting with page access token to show
        uploadedMedia: [],  // getting picture from local system
        selectedPost: [], // media selected from Facebook or instagram video or image
        callToAction: '',
        adCaption: '',
        destinationUrl: '',
        destinationUrlTrackId: '',
        selectedTourLinkId: '',
        selectedTourLinkPage: 1,
        selectedBioLinkId: '',
        selectedTargetImage: '',
        selectedTargetTitle: '',
        selectedYoutubeContent: {},
        youtubeContextChannel: {},
        youtubeDestinationMode: 'myChannel',
        adHeadline: '',
        adDescription: '',  // optional,
        adViewAs: 'facebook',  // ['facebook','instapost','instaReels','instaStory'] — summary preview tab
        isCampaignCreate: false,

        // google camapign data
        isGoogleLogin: false,
        connectedChannels: [],
        selectedChannel: '',
        customerIdList: [],
        youtubeVideoList: [],
        channelVideoShortsList: {
            videos: [],
            shorts: []
        },
        selectedCustomerId: '',
        selectedYoutubeVideo: {},
        advertisingChannelSubType: 'VIDEO_TRUEVIEW_IN_STREAM',  // ['VIDEO_TRUEVIEW_IN_STREAM'(for chepeast),'more-engagement': 'VIDEO_DISCOVERY_AD']
        youtubeTargetCountry: [{
            id: 2384,
            name: "All Countries and Territories",
            countryCode: "GLOBAL",
            type: "CountryGroup"
        }],      // by default global
        youtubeTargetChannels: [],
        youtubeTargetLanguage: [],
        youtubeAgeRange: {
            min: 18,
            max: 65
        },
        youtubeGender: 'All'
    },
    metacampaignList: [],
    metaCampignHistoryList: {
        "total": 0,
        "page": 1,
        "limit": 10,
        camapignList: []
    },
    showCampignList: 'Meta',
    duplicatedCamapignDetails: {
        goal: '',
        startDate: null,
        endDate: null,
        budget: 1,
        budgetType: 'daily',
        currency: '',
        timezone: '',
        minDailyBudget: null,
        audience: [],
        language: [],
        locations: {
            countries: [],
            regions: [],
            cities: [],
        },
        gender: 'All',
        ageRange: {
            min: 18,
            max: 65
        },
        interests: [],
        creatives: [],
        campaignId: '',
        adAccountId: '',
        instaInfo: {},
        pageInfo: {},
        adViewAs: 'facebook'
    },
    metaCampaignAnalytics: {},
    metaCampaignAnalyticsData: {},
    metaCampaignAudienceBreakdown: {}
};

const growthEngine = (state = initialState, action) => {
    switch (action.type) {
        case 'STARTGROWTHENGINE':
            return {
                ...state,
                loading: true,
            };
        case 'GROWTHENGINEFAIL':
        case 'GROWTHENGINESUCCESS':
            return {
                ...state,
                loading: null,
            };
        case 'SET_STEP':
            return {
                ...state,
                currentStep: action.payload, // Update step number
            };
        case 'UPDATE_FORM_DATA':
            return {
                ...state,
                formData: {
                    ...state.formData,
                    ...action.payload, // Merge new form data with existing data
                },
            };
        case 'UPDATE_FORM_DATA_AD_MEDIA':
            return {
                ...state,
                formData: {
                    ...state.formData,
                    uploadedMedia: [...state.formData.uploadedMedia, ...action.payload.uploadedMedia] // Merge new media,
                },
            };
        case 'CANCEL_FORMDATA_STATE':
            return {
                ...initialState, // Reset to initial state
                formData: {
                    ...initialState.formData,
                    metaLoggedIn: state.formData.metaLoggedIn,
                    metaAccessToken: '',
                    facebookUserId: state.formData.facebookUserId,
                    adAccountList: state.formData.adAccountList,
                    adAccountId: '',
                    pageId: state.formData.pageId,
                    pageAccessToken: '',
                    pageList: state.formData.pageList,
                    instagramId: state.formData.instagramId,
                }
            };
        case 'CLEAR_META_CONNECTION_STATE':
            return {
                ...state,
                formData: {
                    ...state.formData,
                    metaAccessToken: '',
                    metaLoggedIn: false,
                    metaAuthPending: false,
                    facebookUserId: '',
                    adAccountList: [],
                    adAccountId: '',
                    pageList: [],
                    pageId: '',
                    pageAccessToken: '',
                    instagramId: '',
                    currency: '',
                    minDailyBudget: null,
                    timezone: '',
                    facebookMediaData: { photos: [], videos: [] },
                    instagramMediaData: [],
                    selectedPost: [],
                },
            };
        case 'RESET_GROWTH_ENGINE':
            return {
                ...initialState,
            };
        case 'GET_TRACK_LIST':
            return {
                ...state,
                artistTrackList: action.list,
                artistTrackType: action.trackType
            };
        case 'SELECT_RELEASE':
            return {
                ...state,
                selectedRelease: action.details
            };
        case 'ALBUM_PLAYLIST_TRACKS':
            return {
                ...state,
                albumPlaylistTracks: action.details
            };
        case 'SELECT_ALBUM_PLAYLIST_TRACK':
            return {
                ...state,
                selectedAlbumPlaylistTrack: action.details
            };
        case 'HANDLE_TRACK_UPDATE':
            return {
                ...state,
                artistTrackType: action.trackType
            };
        case 'RESET_FEATURE_FM_STATE':
            return {
                ...state,
                artistTrackType: action.trackType,
                artistSpotifyProfileUrl: '',
                selectedRelease: {},
                albumPlaylistTracks: {},
                selectedAlbumPlaylistTrack: {},
                artistTrackList: [],
            };
        case 'ADD_ARTIST_URL':
            return {
                ...state,
                artistSpotifyProfileUrl: action.artistURL
            };
        case 'GET_META_CAMPAIGN_LIST':
            return {
                ...state,
                metacampaignList: action.list
            };
        case 'GET_META_CAMPAIGN_HISTORY_LIST':
            return {
                ...state,
                metaCampignHistoryList: {
                    total: action.data?.total || 0,
                    page: action.data?.page || 1,
                    limit: action.data?.limit || 10,
                    campaignList: action.data?.campaignList || []
                }
            };
        case 'SELECT_CAMPAIGNLIST_PLATFORM':
            return {
                ...state,
                showCampignList: action.platform
            };
        case 'DUPLICATE_CAMPAIGN':
            return {
                ...state,
                duplicatedCamapignDetails: {
                    ...state.duplicatedCamapignDetails,
                    ...action.payload, // Merge new camapign data with existing data
                },
            };
        case 'CANCEL_DUPLICATE_CAMPAIGN':
            return {
                ...state, // Reset to initial state
                duplicatedCamapignDetails: initialState.duplicatedCamapignDetails,
            };
        case 'GET_META_CAMPAIGN_ANALYTICS':
            return {
                ...state,
                metaCampaignAnalytics: action.details,
            };
        case 'META_CAMPAIGN_ANALYTICS':
            return {
                ...state,
                metaCampaignAnalyticsData: action.details,
            };
        case 'GET_META_CAMPAIGN_AUDIENCE_BREAKDOWN':
            return {
                ...state,
                metaCampaignAudienceBreakdown: action.details,
            };
        default:
            return state;
    }
};

export default growthEngine;